<!-- <ngx-ui-loader *ngIf="expression"></ngx-ui-loader> -->
<!-- <ngx-loading-x [show]="show">

</ngx-loading-x> -->
<div *ngIf="show"><img src="assets/images/NXT_logo_gif.gif" alt=""
        srcset=""></div>